"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Turkish sentences tend to be shorter because it is a synthetic language. According to our research, sentences that consist of 10 words or above
 * diffciult to read because each word contains suffixes.
 */

exports.default = {
  sentenceLength: {
    recommendedWordCount: 15,
    slightlyTooMany: 20,
    farTooMany: 25
  }
};